import React from "react";

type ScaleProp = {
  min: number;
  max: number;
  value: number;
};

const Scale: React.FC<ScaleProp> = ({ min, max, value }) => {
  const range = max - min;
  const valuePosition = ((value - min) / range) * 100;

  return (
    <div className="w-full relative">
      {/* Labels */}
      <div
        className="absolute w-full flex justify-between mb-1"
        style={{ top: "-20px" }}
      >
        <span
          className="text-[#4E4E4E] text-[0.75rem]"
          style={{ position: "absolute", left: "21%" }}
        >
          {min}
        </span>
        <span
          className="text-[#4E4E4E] text-[0.75rem]"
          style={{ position: "absolute", right: "21%" }}
        >
          {max}
        </span>
      </div>
      {/* Scale Container */}
      <div className="relative flex w-full h-[8px] rounded-md overflow-hidden">
        {/* Left Section (Below Min) */}
        <div
          className="bg-[#FEC472] flex-shrink-0 rounded-full"
          style={{ width: "20%", marginRight: "1%" }}
        ></div>
        {/* Middle Section (Between Min and Max) */}

        <div className="bg-[#2EE290] flex-grow flex items-center justify-between rounded-full"></div>

        {/* Right Section (Above Max) */}
        <div
          className="bg-red-400 flex-shrink-0 rounded-full"
          style={{ width: "20%", marginLeft: "1%" }}
        ></div>
        {/* Value Indicator */}
      </div>

      {/* Value Indicator */}
      <div
        className="absolute left-0 w-1 rounded-full bg-black"
        style={{
          left: value < min ? "11%" : value > max ? "95%" : `${valuePosition < 21 ? valuePosition + 21 : valuePosition > 58 ? valuePosition - 21 : valuePosition}%`,
          height: "200%", // Ensuring it extends beyond the scale height
          top: "-50%", // Adjusting to center vertically on the scale
          transform: "translateX(-50%)",
        }}
      >
        {/* Value Label */}
        <span
          className="absolute top-[-25px] text-black font-[500] text-sm"
          style={{ transform: "translateX(-50%)" }}
        >
          {value}
        </span>
      </div>
    </div>
  );
};

export default Scale;
